import { ROUTERS } from '@/constant';
import { searchParamsKey, useCreateListSubmit } from '@/hooks';
import { cn } from '@/utils';
import { memo, useCallback, useMemo } from 'react';

import Button from '../common/button';
import { DefineAssignmentModalButtonProps } from './define-assignment.type';

const DefineAssignmentButton = (props: DefineAssignmentModalButtonProps) => {
	const {
		className,
		label = '일반 등록(엑셀)',
		btnType = 'default',
		assignmentfranchiseid,
		franchiseId,
		franchiseName,
		districtId,
		startDate,
		endDate,
		isPublicApplicant,
		publicFranchiseId,
		applicantIds,
		callback,
		...restProps
	} = props;

	const toCreatePathName = useMemo(() => {
		const queryProps = {
			assignmentfranchiseid,
			franchiseId,
			franchiseName,
			districtId,
			startDate,
			endDate,
			isPublicApplicant,
			publicFranchiseId,
			applicantIds,
		};
		return `${ROUTERS.DEFINE_ASSIGNMENT}?${searchParamsKey}=${encodeURIComponent(JSON.stringify(queryProps))}`;
	}, [
		assignmentfranchiseid,
		franchiseName,
		districtId,
		franchiseId,
		startDate,
		endDate,
		isPublicApplicant,
		publicFranchiseId,
		applicantIds,
	]);

	const { onCreateSubmit } = useCreateListSubmit({
		toCreatePathName,
	});

	const onClick = useCallback(() => {
		onCreateSubmit?.({
			callbackSuccess: callback,
		});
	}, [onCreateSubmit, callback]);

	return (
		<>
			<Button
				{...restProps}
				className={cn(className)}
				onClick={onClick}
				type={btnType}
			>
				{label}
			</Button>
		</>
	);
};

export default memo(DefineAssignmentButton);
